/**
 * Deep links into the sales CRM (crm.smartorange.space).
 *
 * HUB stopped drawing its own deal/contact/company pages when sales moved to
 * the partner CRM — analytics here, records there. Every "open this deal"
 * link in the portal therefore leaves the portal, and all of them go through
 * this one builder so a change to the CRM's routes is a one-file change.
 *
 * Base URL: REACT_APP_CRM_BASE_URL if set, else the production host.
 * Paths: if the CRM renames a route, fix PATHS below — nothing else.
 */

const BASE = (process.env.REACT_APP_CRM_BASE_URL || "https://crm.smartorange.space").replace(/\/+$/, "");

// Confirmed from a real address bar: the CRM routes records through a hash on
// /crm — https://crm.smartorange.space/crm#deal/01M109ND5KXEMRCMRD4YXT64RN.
// Only `deal` is confirmed; contact and company almost certainly follow the
// same shape, but an unverified guess here is what produced 404s last time, so
// they keep landing on the CRM itself until someone pastes a real one.
const PATHS = {
  deal: (id) => `/crm#deal/${encodeURIComponent(id)}`,
  contact: null,
  company: null,
};

/** Absolute URL for a CRM record, or null when there is no id to link to. */
export function crmUrl(type, id) {
  if (!id) return null;
  const path = PATHS[type];
  if (typeof path !== "function") return BASE;
  return `${BASE}${path(id)}`;
}

export const crmBaseUrl = BASE;

export default crmUrl;
